import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Hombres de 45+ que se levantan 2 o más veces por noche', 'Quienes sienten que nunca vacían por completo (goteo, flujo débil, sensación de "queda algo")', 'Hombres con fatiga diurna por sueño fragmentado', 'Quienes quieren una solución práctica y natural antes de opciones más drásticas'];
  const notForWho = ['Personas que buscan diagnóstico o tratamiento para cáncer de próstata (consulte a su médico)', 'Hombres que no están dispuestos a hacer ajustes mínimos en su ventana nocturna', 'Quien busca una "pastilla mágica" sin cambiar hábitos de cena e hidratación'];
  return <section className="bg-navy-900 py-14 md:py-20 relative text-cream-50" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="max-w-[720px] mx-auto space-y-10" data-id="element-14">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-15">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-16" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-17" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-18" />
          </div>

          <FadeIn data-id="element-19">
            <div className="bg-navy-800 rounded-2xl p-8 md:p-10 shadow-xl border-t-4 border-t-green-500 border border-navy-700" data-id="element-20">
              <h3 className="text-2xl font-heading font-bold text-white mb-8 flex items-center gap-3" data-id="element-21">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-lg" data-id="element-22">
                  <CheckCircle2 size={24} data-id="element-23" />
                </span>
                Para quién es esto
              </h3>
              <ul className="space-y-6" data-id="element-24">
                {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-25">
                    <CheckCircle2 className="text-green-400 shrink-0 mt-1" size={24} data-id="element-26" />
                    <span className="text-lg text-cream-100/90" data-id="element-27">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-28">
            <div className="bg-navy-800 rounded-2xl p-8 md:p-10 shadow-xl border-t-4 border-t-red-500 border border-navy-700" data-id="element-29">
              <h3 className="text-2xl font-heading font-bold text-white mb-8 flex items-center gap-3" data-id="element-30">
                <span className="bg-red-500/20 text-red-400 p-2 rounded-lg" data-id="element-31">
                  <XCircle size={24} data-id="element-32" />
                </span>
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-33">
                {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-34">
                    <XCircle className="text-red-400 shrink-0 mt-1" size={24} data-id="element-35" />
                    <span className="text-lg text-cream-100/90" data-id="element-36">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}